import { render, staticRenderFns } from "./PopupBox.vue?vue&type=template&id=54dce4ec&scoped=true&"
import script from "./PopupBox.vue?vue&type=script&lang=js&"
export * from "./PopupBox.vue?vue&type=script&lang=js&"
import style0 from "./PopupBox.vue?vue&type=style&index=0&id=54dce4ec&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54dce4ec",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('54dce4ec')) {
      api.createRecord('54dce4ec', component.options)
    } else {
      api.reload('54dce4ec', component.options)
    }
    module.hot.accept("./PopupBox.vue?vue&type=template&id=54dce4ec&scoped=true&", function () {
      api.rerender('54dce4ec', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2Kpz1URqTuh3J/JS/comp/PopupBox.vue"
export default component.exports